import { faUserCircle } from "@fortawesome/pro-regular-svg-icons";
import { ActionText } from "./action_text";
import { use_store, tool_map } from "../store";
import { useLocation } from "wouter";

export default function Header() {
  const { tool, user, t_url, t, ln } = use_store();
  const [location, set_location] = useLocation();

  return (
    <>
      <div className="h-[60px]" />

      <div className="flex flex-row justify-between items-center bg-white py-[12px] border-b-[1px] border-lines fixed top-[0px] lg:top-0 left-0 right-0 z-50 px-[16px] overflow-x-auto w-full h-[60px]">
        <div className="flex flex-row justify-between items-center min-w-[1250px] xl:min-w-[1350px] w-full">
          <a
            href={t_url("/")}
            className="flex-row gap-[4px] items-center justify-start cursor-pointer hover:opacity-90 transition-opacity mr-[24px] flex"
          >
            <img src="/favicon_2.webp" className="w-[28px] h-[28px]"></img>
            <p className="logot">{t("LuluLoyal")}</p>
          </a>

          <div className="flex flex-row items-center justify-start smallt flex-1 flex-grow gap-[20px]">
            <p key="all-tool" className="transition-all hover:text-brand-2">
              <ActionText
                onClick={() => {
                  set_location(ln ? `/${ln}/alltools` : "/alltools");
                }}
                text={"All Tools"}
                isActive={location.includes("/alltools")}
              ></ActionText>
            </p>
            {tool_map.map((item, index) => (
              <p key={index} className="transition-all hover:text-brand-2">
                <ActionText
                  onClick={() => {
                    set_location(ln ? `/${ln}${item.href}` : item.href);
                  }}
                  text={t(item.name)}
                  isActive={item.tool === tool}
                ></ActionText>
              </p>
            ))}
          </div>

          {/* Desktop right side actions */}
          <div className="flex flex-row gap-[24px] justify-end items-center">
            <div className="cursor-pointer">
              <ActionText
                text={user ? t("Manage Account") : t("Login")}
                icon={faUserCircle}
                onClick={() => {
                  window.location.href = t_url("/account");
                }}
              ></ActionText>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
